<template>
  <div>
    <div class="bg-white rounded-box shadow-sm p-3 position-relative ai_new_design mb-4">
      <div class="tvm_payment_progress">
        <div class="pt-2 px-3">
          <div class="mb-1 d-flex align-items-center">
            <p class="min_100">Estimated Mileage :</p>
            <p class="pl-3 _theme_font_bold">{{ responseData.estimated_Mileage || "" }}</p>
          </div>
          <div class="d-flex align-items-center">
            <p class="min_100">Condition :</p>
            <p class="pl-3 _theme_font_bold">{{ responseData.condition || "" }}</p>
          </div>
        </div>
        <div class="px-4 pb-3 pt-2 d-flex justify-content-center">
          <div class="position-relative">
            <img class="img-fluid progress_bar" src="/images/value-my-trade.png" alt="value-my-trade" />
            <div class="position-absolute ft-12 left_value">
              <p :class="{ '_theme_font_bold': IsSelectedRough }">${{ rough }}</p>
            </div>
            <div class="position-absolute ft-12 middle_value">
              <p :class="{ '_theme_font_bold': IsSelectedAverage }">${{ average }}</p>
            </div>
            <div class="position-absolute ft-12 right_value">
              <p :class="{ '_theme_font_bold': IsSelectedClean }">${{ clean }}</p>
            </div>
          </div>
        </div>
        <div class="px-3 pt-4">
          <div v-if="responseData && responseData.disclaimer" class="bb-dis mt-2 ft-13"
            v-html="responseData.disclaimer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    responseData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      rough: "",
      average: "",
      clean: "",
      IsSelectedRough: false,
      IsSelectedAverage: false,
      IsSelectedClean: false,
    };
  },

  mounted() {
    if (this.responseData?.bbConditions) {
      let data = JSON.parse(this.responseData.bbConditions);
      data.forEach((item) => {
        switch (item.Condition) {
          case "Rough":
            this.rough = item.Value;
            this.IsSelectedRough = item.IsSelected;
            break;
          case "Average":
            this.average = item.Value;
            this.IsSelectedAverage = item.IsSelected;
            break;
          case "Clean":
            this.clean = item.Value;
            this.IsSelectedClean = item.IsSelected;
            break;
          default:
            break;
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
// reuseable css
.ai_new_design {
  max-width: 600px;
}




.min-120 {
  min-height: 100px;
}

.min_100 {
  display: inline-block;
  min-width: 150px;
  font-size: 13px;
}

// end reuseable css
.tvm_payment_progress {
  .ai_new_design();

  span {
    font-size: 13px;
  }

  .progress_bar {
    height: 45px;
    object-fit: contain;
  }

  .left_value {
    left: -7px;
    top: 35px;
  }

  .middle_value {
    right: 80px;
    top: 42px;
  }

  .right_value {
    right: -7px;
    top: 35px;
  }

  @media screen and (min-width: 1900px) {
    .middle_value {
      right: 100px;
      top: 46px;
    }
  }
}

.animate_bottom {
  animation: animateBottom 2s;
  transition: 0.5s;
}

@keyframes animateBottom {
  0% {
    transform: translateY(50px);
  }

  100% {
    transform: translateY(0);
  }
}

@media (min-width: 1900px) {
  .custom_legend {
    font-size: 13px;
  }
}
</style>
